import React, {useContext} from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { useTranslation } from 'react-i18next';

import DeveloperModeIcon from '@material-ui/icons/DeveloperMode';
import ComselIcon from './icons/ComselIcon';
import LangContext from '../context/LangContext';
//import AcUnitIcon from '@material-ui/icons/AcUnit';

const useStyles = makeStyles((theme) => createStyles({
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  weatherElement: {
    display: "flex",
    alignItems: "center",
    fontSize: theme.typography.h6.fontSize
  },
  weatherIcon: {
    margin: '0 10px',
  }
}));

export const MainAppBar = (props) => {
  const classes = useStyles();
  const [language, setLanguage] = useContext(LangContext);
  const { t } = useTranslation();

  const weSpeakSwedish = () => {
    //i18n.changeLanguage('sv');
   setLanguage('se');
  };
   const weSpeakFinnish = () => {
    //i18n.changeLanguage('fi');
    setLanguage('fi');
   };

  return <AppBar position="static">
  <Toolbar className={classes.toolbar}>
    <div style={{margin: "10px", display: 'flex', justifyContent: 'space-evenly', alignItems:'center'}}>
      <Button onClick={() => props.setDesiredView(10)}>
        {ComselIcon}
      </Button>
<Typography variant="h6" onClick={() => props.setDesiredView(0)}>{t("title")}</Typography>
    </div>
    <div style={{margin: "5px", display: 'flex', justifyContent: 'space-evenly',}}>
      <Button variant={(language==='fi') ? "contained" : "outlined"} style={{ flex: 1, margin: '0 5px' }} onClick={() => weSpeakFinnish()}>FI</Button>
      <Button variant={(language==='se') ? "contained" : "outlined"} style={{ flex: 1, margin: '0 5px' }} onClick= {()=> weSpeakSwedish()}>SE</Button>
      {(process.env.NODE_ENV !== 'production') ?
      <IconButton aria-label="dev" onClick={props.toggleDeveloperMode}>
        <DeveloperModeIcon />
      </IconButton>
      : <></>}
    </div>
  </Toolbar>
  </AppBar>
}


export default MainAppBar;